module.exports = __webpack_public_path__ + "img/画板 6@3x.6bb9fca3.png";